<div class="loader">
  <img class="dd-loading-img" src="assets/icons/loader.svg" alt="Loading...">
</div>
